import request from "../../Utils/curl"
import Utility from "../../Utils/utility"

let OrgProfiles = {
  /**
   * OrgProfile List
   */
  async OrgProfileList (context, whereFilter = null) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      if (whereFilter) {
        postData.append("filter", JSON.stringify(whereFilter))
      }

      return await request.curl(context, "org_profile_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at OrgProfileList() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * OrgProfile View
   */
  async OrgProfileView (context, OrgProfileId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("org_id", OrgProfileId)

      return await request.curl(context, "org_profile_view", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at OrgProfileView() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * OrgProfile Add
   */
  async OrgProfileAdd (context, OrgProfileObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in OrgProfileObj) {
        postData.append(key, OrgProfileObj[key])
      }

      return await request.curl(context, "org_profile_add", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at OrgProfileAdd() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * OrgProfile Edit
   */
  async OrgProfileEdit (context, OrgProfileObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in OrgProfileObj) {
        postData.append(key, OrgProfileObj[key])
      }

      return await request.curl(context, "org_profile_edit", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at OrgProfileEdit() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * OrgProfile Delete
   */
  async OrgProfileDelete (context, OrgProfileId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("org_id", OrgProfileId)

      return await request.curl(context, "org_profile_delete", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at OrgProfileDelete() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * OrgProfile FilterList
   */
  async OrgProfileFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "org_profile_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at org_profile_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  OrgProfiles
}
